// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5475b1bf","453":"75dabde4"}[chunkId] + ".chunk.js";
};